// "dd/mm/yyyy"
// "dd/mm/yy"
// "yyyy/mm/dd"
// "hh:mm"
// "hh:mm:ss"
// "dd/mm/yyyy hh:mm"
// FORMDATE_WITH_TIME
// "dd/mmmm/yyyy hh:mm"
// "hh:mm dd/mmmm/yyyy"
// "ssss"
import dayjs from 'dayjs';


const formatDate = (date) => {
  let parts = date?.split('/');
  let d;

  const [first, second, third] = parts.map(Number);
  const isDayFirst = first < 1000;

  d = new Date(
    isDayFirst ? third : first,
    (second || 1) - 1,         
    isDayFirst ? first : third
  );

  return d;
}

const getDate = (dt, type, divider) => {

  const currentNewDate = new Date();
  const devider = divider ?? "/";

  let d;

  if (typeof dt === 'number') {
    d = new Date(dt);
  } else if (typeof dt === 'string' && dt?.length ==24) {
      const localTimeDt = dt.substring(0, 23)
     d = new Date(localTimeDt);
  }else if(typeof dt ==='string' && dt?.length>10){
    const inputFormat = 'DD.MM.YYYY HH:mm'; 
    const parsedDayjs = dayjs(dt, inputFormat, true);
    if (parsedDayjs.isValid()) {
        d = parsedDayjs.toDate(); 
    } else {
        d = currentNewDate;
    }
  }
  else if(dt?.length==10){
    if(dt.includes('-')){
     d=new Date(dt);
    }else{
    let newD=dt.split('.')[1]+'.'+dt.split('.')[0]+'.'+dt.split('.')[2];
    d=new Date(newD);
    }
  }else {
    d = currentNewDate;
  }

  const date = d; // вже в локальному часі

  const addNull = (param) => param.toString().padStart(2, '0');

  const retMonth = (param) => {
    return [
      'Січня', 'Лютого', 'Березня', 'Квітня', 'Травня', 'Червня',
      'Липня', 'Серпня', 'Вересня', 'Жовтня', 'Листопада', 'Грудня'
    ][param] || param;
  }
  switch (type) {
    
    case "dd/mm/yyyy":
      return `${addNull(date.getDate())}${devider}${addNull(date.getMonth() + 1)}${devider}${date.getFullYear()}`;
    case "dd/mm/yy":
      
      return `${addNull(date.getDate())}${devider}${addNull(date.getMonth() + 1)}${devider}${date.getFullYear().toString().slice(-2)}`;
    case "yyyy/mm/dd":
      return `${date.getFullYear()}${devider}${addNull(date.getMonth() + 1)}${devider}${addNull(date.getDate())}`;
    case "hh:mm":
      return `${addNull(date.getHours())}${devider}${addNull(date.getMinutes())}`;
    case "hh:mm:ss":
      return `${addNull(date.getHours())}${devider}${addNull(date.getMinutes())}${devider}${addNull(date.getSeconds())}`;
    case "dd/mm/yyyy hh:mm":
      return `${addNull(date.getDate())}${devider}${addNull(date.getMonth() + 1)}${devider}${date.getFullYear()} ${addNull(date.getHours())}:${addNull(date.getMinutes())}`;
    case "hh:mm dd/mm/yyyy":
      return `${addNull(date.getHours())}:${addNull(date.getMinutes())} ${addNull(date.getDate())}${devider}${addNull(date.getMonth() + 1)}${devider}${date.getFullYear()}`;
    case "FORMDATE_WITH_TIME":
      return `${date.getFullYear()}-${addNull(date.getMonth() + 1)}-${addNull(date.getDate())}T${addNull(date.getHours())}:${addNull(date.getMinutes())}`;
    case "dd/mmmm/yyyy hh:mm":
      return `${addNull(date.getDate())}${devider}${retMonth(date.getMonth())}${devider}${date.getFullYear()} ${addNull(date.getHours())}:${addNull(date.getMinutes())}`;
    case "dd/mm/yyyy hh:mm:ss":
      return `${addNull(date.getDate())}${devider}${addNull(date.getMonth() + 1)}${devider}${date.getFullYear()} ${addNull(date.getHours())}:${addNull(date.getMinutes())}:${addNull(date.getSeconds())}`;
    case "hh:mm dd/mmmm/yyyy":
      return `${addNull(date.getHours())}:${addNull(date.getMinutes())} ${addNull(date.getDate())}${devider}${retMonth(date.getMonth())}${devider}${date.getFullYear()}`;
    case "dd/mmmm/yyyy":
      return `${addNull(date.getDate())}${devider}${retMonth(date.getMonth())}${devider}${date.getFullYear()}`;
    case "ssss":
      return Math.floor(date.getTime() / 1000);
    default:
      return date;
  }
};

export default getDate;
